import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import * as moment from 'moment';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { EditalDTO } from 'src/app/model/dto/edital.dto';
import { RequerimentoDTO } from 'src/app/model/dto/requerimento.dto';
import { Conta } from 'src/app/model/enum/Conta.enum';
import { TipoChavePix } from 'src/app/model/enum/tipoChavePix.enum';
import { TipoCredito } from 'src/app/model/enum/tipoCredito.enum';
import { TipoCredor } from 'src/app/model/enum/tipoCredor.enum';
import { DataTransferService } from 'src/app/service/data-transfer.service';
import { DocumentoService } from 'src/app/service/documento.service';
import { RequerimentoService } from 'src/app/service/requerimento.service';
import { MaskUtil } from 'src/app/utils/mask-util';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { v4 as uuidv4 } from 'uuid';
import { DocumentoDTO } from "../../../model/dto/documento.dto";
const cep = require('cep-promise');
//import { DocumentoDTO } from '../components/anexar-documentos/anexar-documentos.component';



@Component({
  selector: 'app-formulario-solicitacao-editar',
  templateUrl: './formulario-solicitacao-editar.component.html',
  styleUrls: ['./formulario-solicitacao-editar.component.css']
})
export class FormularioSolicitacaoEditarComponent implements OnInit {

  checked = false;
  indeterminate = false;
  labelPosition = 'after';
  formResultado: FormGroup;
  tipoCredito: TipoCredito;
  tipoCredor: TipoCredor;
  edital: EditalDTO;
  idRequerimento: number;
  idCredor: number;
  documentos: DocumentoDTO[] = []
  documentosEdit: DocumentoDTO[] = []
  date: string;
  totalDocumentos: number;
  minDate = new Date(new Date().getFullYear() - 18);
  tipoCredorInput: number;
  contas: Conta[] = [];
  dataSource = new MatTableDataSource<DocumentoDTO>();
  @BlockUI() blocker: NgBlockUI;
  maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
  docTeste: DocumentoDTO
  file: File;
  arquivosParaAnexar: DocumentoDTO[] = []
  documentosRemovidos: DocumentoDTO[] = []
  dataRecebimento: Date;
  idDadosBancarios: number;
  idAdvogado: number;

  tiposChave = Object.values(TipoChavePix);
  mascaraChavePix: string = '';
  private isDestroyed = false;

  constructor(fb: FormBuilder,
    private dataTransfer: DataTransferService,
    private requerimentoService: RequerimentoService,
    private route: Router,
    private router: ActivatedRoute,
    private documentoService: DocumentoService,
    private toastService: ToasterService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef

  ) {
    this.formResultado = fb.group({
      edital: new FormControl(''),
      cpfCnpj: new FormControl('', [Validators.required]),
      nrPrecatorio: new FormControl(''),
      anoOrcamento: new FormControl(''),
      nome: new FormControl(''),
      dtNascimento: new FormControl(''),
      telefone: new FormControl('', [Validators.required]),
      nrConta: new FormControl('', [Validators.required]),
      nrAgencia: new FormControl('', [Validators.required]),
      banco: new FormControl('', [Validators.required]),
      tpConta: new FormControl('', [Validators.required]),
      cedido: new FormControl(1),
      tipoCredito: new FormControl({ value: '', disabled: true }),
      tipoCredor: new FormControl(''),
      operacao: new FormControl(''),
      tipoChavePix: new FormControl(''),
      chavePix: new FormControl(''),
      credorOriginario: new FormControl({ value: 1, disabled: false }),
      nomeCompleto: new FormControl('', [Validators.required]),
      nomeTitular: new FormControl('', [Validators.required]),
      redimentos: new FormControl(0),
      vinculo: new FormControl(0),
      situacao: new FormControl(0),
      orgao: new FormControl(0),
      numeroMeses: new FormControl(0),
      idProcessoRendimento: new FormControl('', [
        Validators.pattern(/^[0-9]*$/),
        Validators.maxLength(8),
        Validators.minLength(8)
      ]),
      idProcessoSituacao: new FormControl('', [
        Validators.pattern(/^[0-9]*$/),
        Validators.maxLength(8),
        Validators.minLength(8)
      ]),
      idProcessoOrgao: new FormControl('', [
        Validators.pattern(/^[0-9]*$/),
        Validators.maxLength(8),
        Validators.minLength(8)
      ]),
      cpfCnpjRequerente: new FormControl(''),
      outroorgao: new FormControl(''),


    })
  }
  ngOnInit() {
    this.router.params.subscribe(({ idRequerimento }) => {
      this.requerimentoService.buscarPorId(idRequerimento).subscribe(({ data }) => {
        this.edital = data.edital;
        this.idRequerimento = data.id
        this.idCredor = data.credor.id
        this.totalDocumentos = data.documentos.length;
        this.dataRecebimento = data.dataCadastro;
        this.idDadosBancarios = data.credor.dadosBancarios.id;
        this.idAdvogado = data.idAdvogado;
        this.preencherCampos(data);
      });
    });
    Object.values(Conta).forEach(conta => this.contas.push(conta));

    this.formResultado.get('tipoChavePix').valueChanges.subscribe((tipoChavePix: TipoChavePix) => {
      this.configurarValidacaoChavePix(tipoChavePix);
    });

    this.formResultado.get('tipoChavePix').valueChanges.subscribe(tipoChave => {
      this.atualizarMascara(tipoChave);
    });
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
  }

  preencherCampos(requerimento: RequerimentoDTO) {
    this.formResultado.get('edital').setValue(requerimento.edital.nomeEdital);
    this.formResultado.get('nrPrecatorio').setValue(requerimento.numPrecatorio);
    this.formResultado.get('nome').setValue(requerimento.credor.nome);
    this.formResultado.get('anoOrcamento').setValue(requerimento.anoOrcamento);
    this.formResultado.get('tipoCredito').setValue(this.selecionarTipoCredito(requerimento.tipoCredito))
    this.formResultado.get('cpfCnpj').setValue(this.aplicarMascaraCnpjCpf(requerimento.credor.cpfCnpj));
    this.formResultado.get('nome').setValue(requerimento.credor.nome)
    if (requerimento.credor.dataNascimento) {
      this.formResultado.get('dtNascimento').setValue(
        moment(requerimento.credor.dataNascimento).format('DD/MM/YYYY')
      );
    } else {
      this.formResultado.get('dtNascimento').setValue(null);
    }
    this.formResultado.get('telefone').setValue(requerimento.credor.contato)
    this.formResultado.get('tipoCredor').setValue(TipoCredor[requerimento.credor.tipoCredor])
    this.formResultado.get('banco').setValue(requerimento.credor.dadosBancarios.banco)
    this.formResultado.get('tpConta').setValue(Conta[requerimento.credor.dadosBancarios.tipoConta])
    this.formResultado.get('operacao').setValue(requerimento.credor.dadosBancarios.operacao)
    this.formResultado.get('nrAgencia').setValue(requerimento.credor.dadosBancarios.agencia)
    this.formResultado.get('nrConta').setValue(requerimento.credor.dadosBancarios.numeroConta)
    this.formResultado.get('tipoChavePix').setValue(requerimento.credor.dadosBancarios.tipoChavePix)
    this.formResultado.get('chavePix').setValue(requerimento.credor.dadosBancarios.chavePix)
    this.formResultado.get('cpfCnpjRequerente').setValue(this.aplicarMascaraCnpjCpf(requerimento.credor.cpfCnpjRequerente));
    // Novos Campos
    this.formResultado.get('credorOriginario').setValue(requerimento.credor.credorOriginario);
    this.formResultado.get('nomeCompleto').setValue(requerimento.credor.nomeCompleto);
    this.formResultado.get('nomeTitular').setValue(requerimento.credor.dadosBancarios.nomeTitular);
    this.formResultado.get('redimentos').setValue(requerimento.redimentos);
    this.formResultado.get('vinculo').setValue(requerimento.vinculo);
    this.formResultado.get('situacao').setValue(requerimento.situacao);
    this.formResultado.get('orgao').setValue(requerimento.orgao);
    this.formResultado.get('numeroMeses').setValue(requerimento.numeroMeses);
    this.formResultado.get('idProcessoRendimento').setValue(requerimento.idProcessoRendimento);
    this.formResultado.get('idProcessoSituacao').setValue(requerimento.idProcessoSituacao);
    this.formResultado.get('idProcessoOrgao').setValue(requerimento.idProcessoOrgao);
    this.formResultado.get('cedido').setValue(requerimento.credor.cedido);
    this.formResultado.get('outroorgao').setValue(requerimento.outroorgao);

    this.documentosEdit = requerimento.documentos.map((doc) => {
      return { ...doc, uuid: uuidv4(), };
    });
    this.atualizarMascara(requerimento.credor.dadosBancarios.chavePix);
  }

  private atualizarMascara(tipoChave: string): void {
    this.mascaraChavePix = this.getMascaraPorTipo(tipoChave);
    if (!this.isDestroyed) {
      this.cdr.detectChanges();
    }
  }

  private getMascaraPorTipo(tipoChave: string): string {
    switch (tipoChave) {
      case 'CPF':
        return '000.000.000-00';
      case 'CNPJ':
        return '00.000.000/0000-00';
      default:
        return '';
    }
  }

  aplicarMascaraCnpjCpf(valor: string) {
    if (valor.length <= 11) {
      return MaskUtil.cpfToMask(valor);
    } else if (valor.length === 14) {
      return MaskUtil.cnpjToMask(valor);
    } else {
      return valor;
    }
  }

  validarFormulario(): void {
    const tipoChave = this.formResultado.get('tipoChavePix').value;
    const chavePix = this.formResultado.get('chavePix').value;

    if (chavePix) {
      if (tipoChave === 'CPF' && !MaskUtil.validar_cpf(chavePix)) {
        this.formResultado.get('chavePix').setErrors({ invalidCpf: true });
      } else if (tipoChave === 'CNPJ' && !MaskUtil.validar_cnpj(chavePix)) {
        this.formResultado.get('chavePix').setErrors({ invalidCnpj: true });
      } else {
        this.formResultado.get('chavePix').setErrors(null);
      }
    }

    this.formResultado.get('chavePix').markAsTouched();
  }

  exibirCampoChave(): boolean {
    const tipoChavePix = this.formResultado.get('tipoChavePix').value;
    return tipoChavePix === TipoChavePix.CPF || tipoChavePix === TipoChavePix.CNPJ;
  }

  configurarValidacaoChavePix(tipoChave: TipoChavePix): void {
    const chavePixControl = this.formResultado.get('chavePix');
    if (tipoChave) {
      chavePixControl.setValidators([Validators.required]);
    } else {
      chavePixControl.clearValidators();
    }
    chavePixControl.updateValueAndValidity();
  }


  guardarData(event) {
    var timeDiff = Math.abs(Date.now() - new Date(event.value).getTime());
    const age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
    if (age < 18 || isNaN(age)) {
      this.toastService.pop('warning', 'Não é possível cadastrar menores de 18 anos');
      this.formResultado.get('dtNascimento').setValue('');
      return;
    }
    this.date = moment(event.targetElement.value, 'DD/MM/YYYY').locale('en-ca').format('L');



  }
  solicitar() {
    this.montarRequerimento();
  }
  visualizar(documento: DocumentoDTO) {
    this.blocker.start()
    this.documentoService.downloadDocs(documento.key).subscribe(data => {
      const newBlob = new Blob([data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(newBlob);
      window.open(blobUrl, '_blank');
      this.blocker.stop();
    }, error => this.blocker.stop());

  }
  excluirDoc(documento) {
    const removido: DocumentoDTO = this.documentosRemovidos.find(doc => doc.uuid === documento.uuid);
    if (removido) {
      this.documentosEdit.push(removido);
      this.arquivosParaAnexar = this.arquivosParaAnexar.filter(arquivo => arquivo.uuid !== documento.uuid);
    }
  }
  anexar(event, documento: DocumentoDTO) {
    this.file = event.target.files[0];

    if (this.file.size > 5000000) {
      this.toastService.pop('warning', 'Tamanho do anexo excede o limite permitido')
      this.file = null;
      return false;
    }

    const extensao = this.file.name.substr(this.file.name.lastIndexOf('.') + 1, this.file.name.length);

    if (extensao != 'pdf') {
      alert('Formato inválido. Formato permitido PDF');
      return;
    }
    this.arquivosParaAnexar = this.arquivosParaAnexar.filter(arquivo => arquivo.id !== documento.id)
    const documentoAnexo = new DocumentoDTO();
    documentoAnexo.nomeArquivo = this.file.name
    documentoAnexo.arquivo = this.file
    documentoAnexo.tipoDocumento = documento.tipoDocumento
    documentoAnexo.descricao = documento.descricao
    documentoAnexo.uuid = documento.uuid;

    this.arquivosParaAnexar.push(documentoAnexo);
    this.documentosRemovidos.push(documento);
    this.documentosEdit = this.documentosEdit.filter(doc => doc.uuid !== documento.uuid);
  }
  montarRequerimento() {
    this.markAllAsTouched();
    this.validarFormulario();

    if (this.formResultado.get('redimentos').value === 1 && this.formResultado.get('numeroMeses').value < 1) {
      this.toastService.pop('warning', 'Preencha o número de meses.')
      return;
    }


    if (this.formResultado.get('orgao').value === 0) {
      this.toastService.pop(
        'warning',
        'Selecione um Órgão do Estado da Bahia a que pertence o(a) beneficiário(a) originário(a)'
      );
      return;
    }
    if (this.formResultado.get('orgao').value === 10 && (this.formResultado.get('outroorgao').value === null || this.formResultado.get('outroorgao').value === '')) {
      this.toastService.pop(
        'warning',
        'Digite a descrição do outro Órgão do Estado da Bahia a que pertence o(a) beneficiário(a) originário(a)'
      );
      return;
    }


    if (!this.formResultado.valid) {
      this.toastService.pop('warning', 'Preencha todos os campos')
      return;
    }

    this.blocker.start('Processando...')

    const valorDtNascimento = this.formResultado.get('dtNascimento').value;
    let dataNascimentoFormatada: string | null = null; // Inicializa como null

    if (valorDtNascimento) { // Se o campo não está vazio
      const dataMoment = moment(valorDtNascimento, 'DD/MM/YYYY');

      if (dataMoment.isValid()) { // Verifica se o Moment.js conseguiu parsear a data corretamente
        dataNascimentoFormatada = dataMoment.locale('en-ca').format('L'); // Isso resultará em 'YYYY-MM-DD'
      } else {
        // Se a data do formulário for inválida, 'dataNascimentoFormatada' permanece null, 
        // ou você pode logar um aviso para ajudar na depuração.
        console.warn('Data de Nascimento inválida no frontend:', valorDtNascimento);
      }
    }

    const requerimento = {
      id: this.idRequerimento,
      credor: {
        id: this.idCredor,
        nome: this.formResultado.get('nome').value,
        cpfCnpj: this.formResultado.get('cpfCnpj').value.replace(/[^0-9a-zA-Z]+/g, ''),
        dataNascimento: dataNascimentoFormatada,
        contato: this.formResultado.get('telefone').value,
        tipoCredor: this.selecionarCredor(this.formResultado.get('tipoCredor').value),
        // Novos campos do credor DM#14192:
        credorOriginario: this.formResultado.get('credorOriginario').value,
        nomeCompleto: this.formResultado.get('nomeCompleto').value,
        cedido: this.formResultado.get('cedido').value,
        cpfCnpjRequerente: this.formResultado.get('cpfCnpjRequerente').value.replace(/[^0-9a-zA-Z]+/g, ''),

        dadosBancarios: {
          id: this.idDadosBancarios,
          numeroConta: this.formResultado.get('nrConta').value,
          tipoConta: this.pegarTipoContas(this.formResultado.get('tpConta').value),
          agencia: this.formResultado.get('nrAgencia').value,
          banco: this.formResultado.get('banco').value,
          operacao: this.formResultado.get('operacao').value,
          tipoChavePix: this.formResultado.get('tipoChavePix').value,
          chavePix: this.formResultado.get('tipoChavePix').value ? this.formResultado.get('chavePix').value : '',
          // Novo campo do credor DM#14192:
          nomeTitular: this.formResultado.get('nomeTitular').value,
        }
      },
      //Novos campos DM#14192 (diretamente no requerimento):

      redimentos: this.formResultado.get('redimentos').value,
      vinculo: this.formResultado.get('vinculo').value,
      situacao: this.formResultado.get('situacao').value,
      orgao: this.formResultado.get('orgao').value,
      numeroMeses: this.formResultado.get('redimentos').value === 1 ? this.formResultado.get('numeroMeses').value : 0,

      idProcessoRendimento: this.formResultado.get('redimentos').value === 1 ? this.formResultado.get('idProcessoRendimento').value : null,

      idProcessoSituacao: this.formResultado.get('situacao').value === 3 ? this.formResultado.get('idProcessoSituacao').value : null,

      idProcessoOrgao: this.formResultado.get('orgao').value === 10 ? this.formResultado.get('idProcessoOrgao').value : null,

      outroorgao: this.formResultado.get('orgao').value === 10 ? this.formResultado.get('outroorgao').value : '',

      numPrecatorio: this.formResultado.get('nrPrecatorio').value,
      tipoCredito: this.formResultado.get('tipoCredito').value,
      anoOrcamento: this.formResultado.get('anoOrcamento').value,
      edital: this.edital,
      dataRecebimento: this.dataRecebimento,
      idAdvogado: this.idAdvogado

    }
    this.documentos = [...this.documentosEdit, ...this.arquivosParaAnexar];

    requerimento.tipoCredito = this.pegarTipoCredito(requerimento.tipoCredito);
    this.requerimentoService.editarDocumentos(requerimento, this.documentos).subscribe(response => {
      if (response.data !== null) {

        // this.alertaInfo = true;
        // this.msgAlertaInfo = `${response.data.numFormulario}`;
        this.blocker.stop();
        Swal.fire('Confirmação', response.mensagem);
        this.route.navigate(['listar-inscritos'])

        // alert(`${response.data.numFormulario}`)+



      }
    }, err => this.blocker.stop());
  }

  markAllAsTouched() {
    Object.keys(this.formResultado.controls).forEach(key => {
      const control = this.formResultado.get(key);
      if (control) {
        control.markAsTouched();
      }
    });
  }

  pegarTipoContas(value) {
    if (value === 'Poupança') {
      return 'POUPANCA'
    }
    if (value === 'Corrente') {
      return 'CORRENTE';
    }
  }

  pegarDocumentos(documentos: DocumentoDTO[]) {
    this.documentos = documentos;
  }


  selecionarTipoDocumento(event) {
    this.tipoCredorInput = event.value;
  }

  cancelar() {
    this.route.navigate(['listar-inscritos']);
  }

  public cpfcnpjmask = function (rawValue) {
    var numbers = rawValue.match(/\d/g);
    var numberLength = 0;
    if (numbers) {
      numberLength = numbers.join('').length;
    }
    if (numberLength <= 11) {
      return [
        /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/,];
    } else {
      return [
        /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-',
        /[0-9]/, /[0-9]/,];
    }
  };
  public precatoriomask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  public numContaMask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  public cepMask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/];

  selectFile() {
    let element: HTMLElement = document.querySelector('input[type="file"]') as HTMLElement;
    element.click();
  }
  private selecionarTipoCredito(value: TipoCredito) {
    if (value.toString() === "ALIMENTAR") {
      return 1;
    } else {
      return 0;
    }
  }

  private pegarTipoCredito(value: number) {
    if (value === 0) {
      return 'COMUM'
    } else {
      return 'ALIMENTAR'
    }
  }

  private selecionarCredor(value: number) {
    if (value === 1 || value === undefined) {
      return TipoCredor.SUCESSOR
    }
    if (value === 0) {
      return TipoCredor.ORIGINARIO
    }
    if (value === 3) {
      return TipoCredor.CESSIONARIO
    }
  }

}
